import { render, staticRenderFns } from "./LandingSideNav.vue?vue&type=template&id=72174dda&scoped=true&"
import script from "./LandingSideNav.vue?vue&type=script&lang=js&"
export * from "./LandingSideNav.vue?vue&type=script&lang=js&"
import style0 from "./LandingSideNav.vue?vue&type=style&index=0&id=72174dda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72174dda",
  null
  
)

export default component.exports